<template>
    <div class="card" style=" overflow: hidden;">
        <div class="card-body m-2">
            <div class="row p-2 mb-3">
                <div class="d-row d-flex align-items-center">

                    <div class="col-3">
                        <input type="text" class="form-control form-control-sm rounded-pill"
                            placeholder="&#xF002; Search Reports..." @keyup="onSearch()" v-model="search" disabled
                            style="font-size: 15px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free';" />
                    </div>

                    <div class="ms-2 col-7 button-container">
                        <!-- Create Selection Box -->
                    </div>

                    <!-- FILTERS -->
                    <div class="col-2 d-flex flex-row justify-content-start">

                        <div class="d-flex flex-row align-items-center">
                            <span class="p-2 filter-title">Report:</span>
                            <select v-model="chosenReport" class="form-select shadow-none filter-options"
                                style="width:auto;border:none">
                                <option v-for="filter in filterByList" :value="filter.value" :key="filter.value">{{
                                    filter.text }}
                                </option>
                            </select>
                        </div>

                        <!-- <div class="d-flex flex-row align-items-center">
                            <span class="p-2 filter-title">Sort by:</span>
                            <select v-model="sortBy" class="form-select shadow-none filter-options"
                                style="width:auto;border:none">
                                <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{
                                    sortBy.text }}
                                </option>
                            </select>
                        </div>

                        <div class="d-flex flex-row align-items-center">
                            <span class="p-2 filter-title">Rows Per Page:</span>
                            <select v-model="pagination.pageSize"
                                class="form-select form-select-sm shadow-none filter-options">
                                <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}
                                </option>
                            </select>
                        </div> -->

                    </div>

                </div>
            </div>

            <div class="row p-2 mt-2">
                <table class="table align-middle main-table">

                    <thead class="align-middle">
                        <tr>
                            <th class="tr-color-light" scope="col" v-for="header in headers[chosenReport]"
                                :key="header.value">{{
                                    header.text }}
                            </th>
                        </tr>
                    </thead>

                    <!-- <tbody v-if="this.pagination.totalItems <= 0">
                        <tr>
                            <td colspan="4">
                                No records to display.
                            </td>
                        </tr>
                    </tbody> -->

                    <tbody v-if="reports.length <= 0">
                        <tr>
                            <td colspan="4">
                                No records to display.
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-if="chosenReport == 'active_accounts'">
                        <tr v-for="(report, index) in reports" :key="index">
                            <td style="max-width: 50px;">
                                {{ report.account_name }}</td>
                            <td style="max-width: 50px;">
                                {{ formatDate(report.date_created) }}</td>
                            <td style="max-width: 50px;">
                                {{ `${report.days_active} day(s) ago` }}</td>
                        </tr>
                    </tbody>

                    <tbody v-if="chosenReport == 'active_devices'">
                        <tr v-for="(report, index) in reports" :key="index">
                            <td style="max-width: 50px;">
                                {{ report.account_name }}</td>
                            <td style="max-width: 50px;">
                                {{ formatDate(report.date_created) }}</td>
                            <td style="max-width: 50px;">
                                {{ `${report.active_devices} Unique devices` }}</td>
                        </tr>
                    </tbody>

                    <tbody v-if="chosenReport == 'inactive_account'">
                        <tr v-for="(report, index) in reports" :key="index">
                            <td style="max-width: 50px;">
                                {{ report.account_name }}</td>
                            <td style="max-width: 50px;">
                                {{ formatDate(report.date_created) }}</td>
                            <td style="max-width: 50px;">
                                {{ `${report.inactive_devices} Unique devices` }}</td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <!-- START -- PAGINATION -->
            <!-- <div class="row text-center">

                <div class="d-inline pagination">
                    <a @click="previousPage()" style="margin-right: 8px; color: #00a0c1;"
                        :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == 1">
                        <i class="fa fa-chevron-left"></i>
                    </a>
                    <span>
                        <strong>
                            <span> {{ paginationLabel }} of {{ this.pagination.totalItems }} </span>
                        </strong>
                    </span>
                    <a @click="nextPage()" style="margin-left: 8px; color: #00a0c1;" :style="this.pagination.page == this.pagination.totalPages
                        || this.pagination.totalItems == 0 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                </div>

            </div> -->
            <!-- END -- PAGINATION -->
        </div>
    </div>
    <!-- ========== END -- CARD ========== -->
</template>
 
<script>
import moment from 'moment'
import { debounce } from '@/plugins/helper.js'

export default ({

    components: {

    },

    data() {
        return {
            headers: {
                "active_accounts": [
                    { text: "Account Name", value: "accountName" },
                    { text: "Date and Time", value: "dateAndTime" },
                    { text: "Last Active Day", value: "lastActiveDay" },
                ],
                "active_devices": [
                    { text: "Account Name", value: "accountName" },
                    { text: "Date and Time", value: "dateAndTime" },
                    { text: "Active Device Count", value: "activeDeviceCount" },
                ],
                "inactive_accounts": [
                    { text: "Account Name", value: "accountName" },
                    { text: "Date and Time", value: "dateAndTime" },
                    { text: "Active Device Count", value: "activeDeviceCount" },
                ]
            },
            chosenReport: "active_accounts",
            filterByList: [
                { text: "Active Accounts", value: "active_accounts" },
                { text: "Inactive Devices", value: "inactive_accounts" },
                { text: "Active Devices", value: "active_devices" },
            ],
            search: "",
            reports: [],
            debounceFn: null,
            paginationData: {},
            pagination: {
                pageSize: 50,
                page: 1,
                totalItems: 0,
                totalPages: 1,
            },
            rowsPerPageList: [
                { text: "50", value: 50 },
                { text: "75", value: 75 },
                { text: "100", value: 100 },
            ],
            sortByList: [
                { text: "Date: Newest", value: "dateCreated_desc" },
                { text: "Date: Oldest", value: "dateCreated_asc" },
            ],
            sortBy: "dateCreated_desc", //default option
            sorting: {
                field: "name",
                order: "desc"
            },
        }
    },

    computed: {
        paginationLabel() {
            var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
            var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

            return start + " - " + end
        },

        currentPage() {
            return this.pagination.page
        },

        rowsPerPage() {
            return this.pagination.pageSize
        },

        sortItems() {
            return this.sortBy
        },

        reportType() {
            return this.chosenReport
        }

    },

    watch: {
        currentPage() {
            this.getVertexReport()
        },

        reportType() {
            return this.getVertexReport()
        },

        rowsPerPage() {
            this.pagination.page = 1
            this.getVertexReport()
        },

        sortItems() {
            if (this.sortBy.includes("_")) {
                let sort = this.sortBy.split("_")
                this.sorting.field = sort[0]
                this.sorting.order = sort[1]
            } else {
                this.sorting.field = this.sortBy
                this.sorting.order = ""
            }
            this.getVertexReport()
        },
    },

    created() {
        this.init()

        // for setting the delay of calling the function when searching
        this.debounceFn = debounce(() =>
            this.getVertexReport()
            , 500)
    },

    mounted() {
    },

    methods: {

        init() {
            this.getVertexReport()
        },

        formatDate(date) {
            return moment(date).format("DD-MMM-YYYY @ HH:mm:ss")
        },

        previousPage() {
            this.pagination.page > 1 ? this.pagination.page -= 1 : ''
        },

        nextPage() {
            this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
        },

        onSearch() {
            this.debounceFn()
            this.pagination.page = 1
        },

        truncateText(text, limit) {

            if (text === null)
                return
            if (text === '')
                return

            if (text.length <= limit) {
                return text; // Return the original text if it's within the limit
            } else {
                return text.slice(0, limit) + '...'; // Truncate the text and add ellipsis
            }
        },

        trimQuestionMark(text) {
            let index = text.indexOf('?')

            if (index > 0) {
                return text.substring(0, index)
            } else {
                return text
            }
        },

        //function
        async getVertexReport() {

            this.reports = []

            let apiPath = "admin-controls/get-vertex-report?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page + "&report_type=" + this.chosenReport

            if (this.sorting.order != "") {
                apiPath += "&order_by=" + this.sorting.order
            }

            if (this.search !== "" || this.search !== null) {
                apiPath += "&search=" + this.search
            }

            await this.$axios.get(apiPath)
                .then((response) => {

                    console.log(response)
                    if (response.data.report_data === "No Record Found")
                        this.reports = []
                    else {
                        //console.log(response.data.report_data)
                        this.reports = response.data.report_data
                    }
                    this.paginationData = response.data.pagination
                    this.pagination.totalItems = this.paginationData.total_count
                    this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error("An error has occured.")
                })
        },
    },

})


</script>
<style scoped>
.button-container {
    display: flex;
    gap: 15px;
    /* Adjust this value for the desired spacing */
}

.card {
    border: none;
}

.card-title {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: #435666;
}

.table {
    border: 0px 0px 1px 0px;
    font-size: 15px
}

.input-group-append {
    cursor: pointer;
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #00A0C1;
    color: #00A0C1;
}

.btn-circle-trash {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #EB1C24;
    color: #EB1C24;
}

.btn-circle-trash:hover {
    border: 1px solid #EB1C24;
    color: whitesmoke;
    background-color: #EB1C24;
}

.btn-circle-check {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #00A36C;
    color: #00A36C;
}

.btn-circle-check:hover {
    background-color: #00A36C;
    color: whitesmoke;
    border: 1px solid #00A36C;
}

.btn-circle:hover {
    border: 1px solid #00A0C1;
    background-color: #00A0C1;
    color: whitesmoke;
}

.btn-circle:focus {
    border: 1px solid #00A0C1;
    color: #00A0C1;
}

.btn-info-outline {
    background-color: white;
    border-color: #00a0c1;
    color: #00a0c1;
}

.btn-info-outline:hover {
    background-color: #00a0c1;
    border-color: #00a0c1;
    color: whitesmoke;
}

.btn-info-outline-active {
    background-color: #00A54F;
    border-color: #00A54F;
    color: whitesmoke;
}

.btn-info:focus,
.btn-info:hover,
.btn-info:active {
    background-color: #00a0c1;
    border-color: #00a0c1;
    opacity: 0.9
}

.btn-info:disabled {
    background-color: #00343f;
    border-color: #00343f;
}

.btn-outline-info {
    color: #00a0c1;
    border-color: #00a0c1;
}

.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:active {
    color: #fff;
    background-color: #00a0c1;
    border-color: #00a0c1;
}

/* tr color */
.tr-color-light {
    background-color: #f5f5f5;
    border: #f5f5f5;
}

.btn-outline-verify {
    background-color: white;
    border-color: #00a0c1;
    color: #00a0c1
}

.btn-outline-verify:hover {
    color: #fff;
    background-color: #00a0c1;
    border-color: #00a0c1;
}

.bg-blur {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
}


.input-group-text-outline {
    background-color: white;
    border-color: #00a0c1;
    color: #00a0c1
}
</style>
 
 